import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import withBraze from '../../utils/withBraze';
import placements from '../../Placements';
import isElementVisible from '../../utils/isElementVisible';
import { Styled } from './TeaserConsumer.styles';
const PLACEMENT = placements.TEASER;
const TeaserImage = ({ onCardShown, onCardClicked, imageUrl, linkText, url, portalContainerRef, openTarget, }) => {
    const [adShown, setAdShown] = useState(false);
    const [imageLoaded, setImageLoaded] = useState(false);
    const resizeHandler = () => {
        if (!adShown &&
            portalContainerRef.current &&
            isElementVisible(portalContainerRef.current)) {
            setAdShown(true);
            window.removeEventListener('resize', resizeHandler);
        }
    };
    useEffect(() => {
        if (adShown)
            onCardShown();
    }, [adShown]);
    useEffect(() => {
        if (imageLoaded &&
            portalContainerRef.current &&
            isElementVisible(portalContainerRef.current)) {
            setAdShown(true);
            window.removeEventListener('resize', resizeHandler);
        }
    }, [imageLoaded]);
    useEffect(() => {
        window.addEventListener('resize', resizeHandler);
        return () => window.removeEventListener('resize', resizeHandler);
    }, []);
    return (_jsx(Styled.Container, { children: _jsx("a", { "data-qa": "teaser-link", target: openTarget, rel: "noopener noreferrer", href: url, onClick: onCardClicked, children: _jsx(Styled.Image, { onLoad: () => setImageLoaded(true), src: imageUrl, alt: linkText, title: linkText }) }) }));
};
const Teaser = ({ payload: { campaignId, imageUrl, linkText, url, openTarget }, trackingLibrary, }) => {
    const portalContainerRef = React.useRef(null);
    const onCardShown = () => {
        trackingLibrary === null || trackingLibrary === void 0 ? void 0 : trackingLibrary.trackCardImpression(PLACEMENT, campaignId);
    };
    const onCardClicked = () => {
        trackingLibrary === null || trackingLibrary === void 0 ? void 0 : trackingLibrary.trackCardClick(PLACEMENT, campaignId);
    };
    return (_jsx("div", { ref: portalContainerRef, children: _jsx(TeaserImage, { portalContainerRef: portalContainerRef, url: url, imageUrl: imageUrl, linkText: linkText, onCardShown: onCardShown, onCardClicked: onCardClicked, openTarget: openTarget }) }));
};
const TeaserConsumer = withBraze(PLACEMENT)(Teaser);
export { TeaserConsumer, Teaser };
//# sourceMappingURL=TeaserConsumer.js.map